"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_URL = exports.ENVIRONMENT = void 0;
exports.ENVIRONMENT = 'Dev';
exports.API_URL = 'https://api.multiplayer.semsom.dev.app.zwijsen.nl';
